module.exports = __webpack_public_path__ + "img/Frame 6.ba8e5fb7.png";